/* eslint-disable @typescript-eslint/no-explicit-any */
// ** Store Imports
import { handleFooterType } from "@src/redux/layout";
import type { RootState } from "@src/redux/store";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/redux/hooks";

export const useFooterType = () => {
  // ** Hooks
  const dispatch = useAppDispatch();
  const store = useSelector((state: RootState) => state.layout);

  const setFooterType = (type: any) => {
    dispatch(handleFooterType(type));
  };

  return { setFooterType, footerType: store.footerType };
};
